import React from 'react';
import analytics from '@react-native-firebase/analytics';
import {Container, Title} from './styles';
import {PixPaymentMethod} from '../../../PixPaymentMethod';
import {UserCreditCardsDTO} from '../../../../../../dtos/UserCreditCardsDTO';

type PaymentMethod = 'PIX' | 'TICKETLOG' | UserCreditCardsDTO | null;

type Props = {
  selectedPaymentMethod: PaymentMethod;
  changePaymentMethod: (method: PaymentMethod) => void;
};

export function CheckoutPix({selectedPaymentMethod, changePaymentMethod}: Props) {
  function handleChangePaymentMethod(method: PaymentMethod) {
    if (method === 'PIX') {
      analytics().logEvent('checkout_selecionou_pix');
    }
    changePaymentMethod(method);
  }

  return (
    <Container>
      <Title>Pague com PIX</Title>
      <PixPaymentMethod
        selectedPaymentMethod={selectedPaymentMethod}
        changePaymentMethod={handleChangePaymentMethod}
      />
    </Container>
  );
}